const ADMIN_TAX_APPROVAL = {
  SET_TAX_APPROVAL: 'SET_ADMIN_TAX_APPROVAL',
};
export default ADMIN_TAX_APPROVAL;
